import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { ChargeCalculation } from '../../data/entities';

interface SearchableChargeCalcDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  defaultItem?: boolean;
  disabled?: boolean;
}

export const SearchableChargeCalcDropdown = React.forwardRef(
  (
    props: Readonly<SearchableChargeCalcDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const [options, setOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
    
      const chargeCalcOptions = Object.values(ChargeCalculation).map<DropdownOption>((type)=>({
        value: type.toString(),
        text: type.toString()
      }))
      setOptions(chargeCalcOptions)

    }, []);

    const getValue = () => {
      if (!props.value && props.defaultItem) {
        return {text:"Select a calculation...", value:""}
      }
      return options.find((option) => option.value === props.value?.toString());
    }

    return (
      <SearchableDropdown
        defaultItem={props.defaultItem ? {text:"Select a calculation...", value:""} : undefined}
        label="Charge Calculation"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
        disabled={props.disabled}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableChargeCalcDropdown
